import ButtonComponent from 'components/ButtonComponent';
import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    padding-bottom: 10%;
    font-family: 'Regular' !important;
`;

export const BorderTable = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 1100px;
    max-width: 1500px;
    width: 90%;
    border: 2.5px solid ${({ theme }) => theme.colors.yellow_ipiranga};
`;

export const Title = styled.h1`
    color: #333;
    text-align: start;
    margin: 30px 0px 50px 16px;
`;

export const ContainerInputs = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 30px;
`;

export const FormGroup = styled.div`
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0px 16px 16px 0px;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    margin: 0px 16px 0px 16px;
`;

export const FormJustification = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
`;



export const Label = styled.label`
    font-weight: bold;
    color: #555;
    margin-bottom: 16px;
`;

export const TextArea = styled.textarea`
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    min-height: 100px;
    resize: vertical;

    &:focus {
        outline: none;
        border-color: #4a90e2;
        box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
    }
`;

export const FileInputLabel = styled.label`
    padding: 10px 15px;
    background-color: #00266e;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    transition: background-color 0.3s;

    &:hover {
        background-color: #357ab8;
    }
`;

export const FileInput = styled.input`
    display: none;
`;

export const PreviewImage = styled.img<{ show: boolean }>`
    max-width: 100%;
    max-height: 300px;
    margin-top: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: ${(props) => (props.show ? 'block' : 'none')};
`;

export const ContainerButton = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 30px;
`;

export const SubmitButton = styled(ButtonComponent).attrs({
    style: {
        paddingLeft: 100,
        paddingRight: 100,
        paddingTop: 19,
        paddingBottom: 19,
        marginRight: 24,
        fontWeight: 'bold',
    },
})``;

export const ErrorMessage = styled.p`
    color: #dc3545;
    font-size: 14px;
    margin-top: 5px;
`;

export const LoadingSpinner = styled.div`
    border: 25px solid #00266e;
    border-radius: 50%;
    border-top: 25px solid white;
    width: 150px;
    height: 150px;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const DragDropContainer = styled.div<{ isDragging: boolean }>`
    border: 2px dashed
        ${({ theme, isDragging }) =>
            isDragging ? theme.colors.chumbo : theme.colors.blue_ipiranga};
    border-radius: 8px;
    padding: 32px;
    text-align: center;
    cursor: pointer;
    background-color: ${({ theme, isDragging }) =>
        isDragging ? theme.colors.yellow_ipiranga : 'transparent'};
    transition: all 0.3s ease;
`;

export const DragDropText = styled.p`
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.black};
`;

export const DragDropButton = styled.button`
    background: ${({ theme }) => theme.colors.blue_ipiranga};
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.3s ease;

    &:hover {
        background: ${({ theme }) => theme.colors.blue_quaternary};
    }
`;

export const PreviewContainer = styled.div`
    position: relative;
    display: inline-block;
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    background: ${({ theme }) => theme.colors.red_1};
    color: white;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    padding: 0;
`;

export const FullScreenLoader = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;
